import SuburbPestControlPage from "../components/SuburbPestControlPage";
import { IPSWICH_SUBURBS } from "../data/ipswichSuburbs";

export default function PestControlBellbirdParkPage() {
  return <SuburbPestControlPage suburb={IPSWICH_SUBURBS["bellbird-park"]} />;
}
